import React from "react";

/**
 * LogoLockup — official brand lockups extracted verbatim from the
 * Manual de Marca VdV (Junio 2023). Three variants are supported:
 *
 *   variant="full"        → page 4 hero lockup. Stacked "VIAJA DE VERDAD."
 *                           wordmark with the "Focused on you." script
 *                           tagline below. Used wherever the brand needs
 *                           full presence (login overlay, footer, /the-collection).
 *   variant="horizontal"  → page 5 "Versión Abreviada Horizontal".
 *                           VdV. monogram + thin divider + script tagline,
 *                           on one line. Used in the PDF header where
 *                           vertical space is scarce.
 *   variant="wordmark"    → page 5 "Logotipo sin Tag Line". Just the
 *                           "VIAJA DE VERDAD." wordmark, no tagline.
 *
 * Each variant ships in two color treatments:
 *   tone="light"  → navy ink on cream background (asset as exported
 *                   from the brand manual). Use over ivory / pearl.
 *   tone="dark"   → cream ink on transparent background. Use over
 *                   deep-blue, charcoal, or photographic backgrounds.
 */
const SIZE_MAP = {
  sm: 80,
  md: 120,
  lg: 160,
  xl: 200,
  "2xl": 220,
};

const VARIANT_BASE = {
  full: "vdv-lockup-full",
  horizontal: "vdv-monogram-tagline-horizontal",
  wordmark: "vdv-wordmark-only",
};

export default function LogoLockup({
  variant = "full",
  size = "lg",
  tone = "dark",
  className = "",
  ...rest
}) {
  const height = typeof size === "number" ? size : SIZE_MAP[size] || 160;
  const base = VARIANT_BASE[variant] || VARIANT_BASE.full;
  const src =
    tone === "light"
      ? `/static/brand/${base}-transparent.png`
      : `/static/brand/${base}-onDark.png`;
  return (
    <img
      src={src}
      alt="Viaja de Verdad — Focused on you."
      data-testid={`logo-lockup-${variant}`}
      draggable={false}
      decoding="sync"
      loading="eager"
      style={{ height, width: "auto", display: "block" }}
      className={`select-none ${className}`}
      {...rest}
    />
  );
}
